import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_ERRACHIDIA_ATLAS_FEZ } from "@/lib/itineraryHubs";

export default function ErrachidiaAtlasFezHubPage() {
  return <ItineraryHubPage hub={HUB_ERRACHIDIA_ATLAS_FEZ} />;
}
